import challengeIntroDialogTemplate from './challenge-intro-dialog.tpl.html';
import './challenge-intro-dialog.less';
import { globalEventsComponentModule } from '../../../../shared/app/components/global-events/global-events-directive';
import { EDIT_MODE_LABELS } from '../../../../shared/app/models/assessment-result';
import { GLOBAL_ACTION_EVENTS } from '../../../../shared/app/components/global-actions/global-actions';

export const challengeIntroDialogComponentModule = angular
  .module('Q.components.challenge-intro-dialog', [globalEventsComponentModule])

  .component('challengeIntroDialog', {
    bindings: {
      showIntro: '<',
      assessmentProcess: '<',
      challenge: '<',
      beginChallenge: '&',
    },
    transclude: true,
    controller: 'ChallengeIntroDialogCtrl',
    template: challengeIntroDialogTemplate,
  })

  .controller(
    'ChallengeIntroDialogCtrl',
    function ChallengeIntroDialogCtrl(
      $scope,
      $element,
      $animate,
      $timeout,
      $log,
    ) {
      const ctrl = this;

      ctrl.enabled = false;

      let listener = angular.noop;

      const setEnabled = (enabled) => {
        ctrl.enabled = enabled;
        $element.toggleClass('enabled', enabled);

        listener();
        if (enabled) {
          listener = $scope.$on(
            'socket:model.changed:Solution',
            ($event, data) => {
              const newSolution = data.model;
              if (
                ctrl.showIntro &&
                newSolution &&
                newSolution.challengeId === ctrl.challenge.id &&
                newSolution.assessmentResultId === ctrl.assessmentResult.id
              ) {
                // solution was created elsewhere, start the challenge now
                ctrl.beginChallenge();
              }
            },
          );
        }
      };

      ctrl.$onInit = () => {
        if (!ctrl.assessmentProcess) {
          return $log.error(
            'Invariant violation: ctrl.assessmentProcess was unexpectedly undefined',
          );
        }

        ctrl.assessmentResult = ctrl.assessmentProcess.assessmentResult;
        ctrl.restricted = ctrl.assessmentProcess.restricted;
        ctrl.modeLabel = () =>
          (
            EDIT_MODE_LABELS[ctrl.assessmentProcess.editMode] || ''
          ).toLowerCase();
        ctrl.next = ctrl.assessmentProcess.next;

        setEnabled(ctrl.showIntro);

        ctrl.$onChanges = () => {
          if (ctrl.enabled && !ctrl.showIntro) {
            let $children = $element.children();
            let childCounts = $children.length;
            angular.forEach($children, (child) => {
              $animate.removeClass(child, 'in').then(() => {
                childCounts--;
                if (childCounts <= 0) {
                  setEnabled(false);
                }
              });
            });

            // should be unnecessary, but I refuse to let this issue return.
            // this ensures that, if something breaks with the animations, we _always_ remove
            // the overlays after 1 second
            $timeout(() => {
              setEnabled(false);
            }, 1000);
          }
        };
      };

      // allow global keystrokes for "next"
      $scope.$on(GLOBAL_ACTION_EVENTS.run, ($event) => {
        if (ctrl.enabled && ctrl.showIntro) {
          $event.preventDefault();
          ctrl.beginChallenge();
          $scope.$apply();
        }
      });
    },
  );
